import { render, staticRenderFns } from "./Mainbar.vue?vue&type=template&id=6529ec24&scoped=true"
import script from "./Mainbar.vue?vue&type=script&lang=js"
export * from "./Mainbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6529ec24",
  null
  
)

export default component.exports